export default "__VITE_ASSET__28e0ff81__"